"use strict";
/**
 * https://www.figma.com/file/NDYFGMfDaxqqY41C55RDgl/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8469%3A38034&t=a8d20mmtori6OOti-1
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorValue = exports.colorNames = exports.colors = void 0;
exports.colors = {
    blue: {
        100: '#FBFCFE',
        200: '#EEF5FB',
        300: '#E0F0FF',
        400: '#C7E4FF',
        500: '#8BC7FF',
        600: '#2A93F4',
        700: '#087CBF',
        800: '#2B464D',
    },
    green: {
        100: '#FAFFF5',
        200: '#F0FCE4',
        300: '#E7F9D2',
        400: '#C9EBA3',
        500: '#A4D36E',
        600: '#56AA41',
        700: '#496728',
        800: '#384B23',
    },
    grey: {
        100: '#FCFBF8',
        200: '#F6F5EF',
        300: '#F0EFE4',
        400: '#DEDCCE',
        500: '#B6B4AA',
        600: '#7F7B71',
        700: '#555249',
        800: '#25241D',
    },
    orange: {
        100: '#FEFAF5',
        200: '#FEF3E6',
        300: '#FFE6C9',
        400: '#FFC9A3',
        500: '#FF9F6B',
        600: '#F4722A',
        700: '#B64617',
        800: '#893815',
    },
    red: {
        100: '#FFFBFA',
        200: '#FFF2F0',
        300: '#FFE1DD',
        400: '#FBC2B6',
        500: '#F99D8F',
        600: '#DC4C56',
        700: '#9E3D3D',
        800: '#843435',
    },
    transparent: 'transparent',
    white: '#FFF',
    yellow: {
        100: '#FFFDF5',
        200: '#FEFAE2',
        300: '#FFF5D2',
        400: '#FCF0B6',
        500: '#FFEB85',
        600: '#FEE827',
        700: '#8E6A15',
        800: '#47350B',
    },
};
exports.colorNames = Object.keys(exports.colors);
const getColorValue = (color) => {
    const [name, shade] = color.split('.');
    if (shade) {
        return exports.colors[name][shade];
    }
    return exports.colors[name];
};
exports.getColorValue = getColorValue;
